import React from "react";
import VisibilityIcon from "@material-ui/icons/Visibility";
import AddShoppingCartIcon from "@material-ui/icons/AddShoppingCart";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import StarIcon from "@material-ui/icons/Star";
import { NavLink } from "react-router-dom";

function Poducts() {
  return (
    <>
      <div className="row">
        <div className="col-md-4">
          <div className="card mb-4 product-wap rounded-0">
            <div className="card rounded-0">
              <img
                className="card-img rounded-0 img-fluid"
                src={
                  "https://res.cloudinary.com/talhakash/image/upload/v1618827556/nl2r24eyzbpiwyuypesh.jpg"
                }
                alt="pic.jpg"
              />
              <div className="card-img-overlay rounded-0 product-overlay d-flex align-items-center justify-content-center">
                <ul className="list-unstyled">
                  <li>
                    <NavLink className="btn btn-success text-white" to="/ProductDetails">
                      <FavoriteBorderIcon />
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="btn btn-success text-white mt-2"
                      to="/ProductDetails"
                    >
                      <VisibilityIcon />
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="btn btn-success text-white mt-2"
                      to="/ProductDetails"
                    >
                      <AddShoppingCartIcon />
                    </NavLink>
                  </li>
                </ul>
              </div>
            </div>
            <div className="card-body">
              <NavLink to="/ProductDetails" className="h3 text-decoration-none">
                Oupidatat non
              </NavLink>
              <ul className="w-100 list-unstyled d-flex justify-content-between mb-0">
                <li>M/L/X/XL</li>
                <li className="pt-2">
                  <span className="product-color-dot color-dot-red float-left rounded-circle ml-1"></span>
                  <span className="product-color-dot color-dot-blue float-left rounded-circle ml-1"></span>
                  <span className="product-color-dot color-dot-black float-left rounded-circle ml-1"></span>
                  <span className="product-color-dot color-dot-light float-left rounded-circle ml-1"></span>
                  <span className="product-color-dot color-dot-green float-left rounded-circle ml-1"></span>
                </li>
              </ul>
              <ul className="list-unstyled d-flex justify-content-center mb-1">
                <li>
                  <StarIcon className="text-warning" />
                  <StarIcon className="text-warning" />
                  <StarIcon className="text-warning" />
                  <StarIcon className="text-muted" />
                  <StarIcon className="text-muted" />
                </li>
              </ul>
              <p className="text-center mb-0">$250.00</p>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card mb-4 product-wap rounded-0">
            <div className="card rounded-0">
              <img
                className="card-img rounded-0 img-fluid"
                src={
                  "https://res.cloudinary.com/talhakash/image/upload/v1618827556/nl2r24eyzbpiwyuypesh.jpg"
                }
                alt="pic.jpg"
              />
              <div className="card-img-overlay rounded-0 product-overlay d-flex align-items-center justify-content-center">
                <ul className="list-unstyled">
                  <li>
                    <NavLink className="btn btn-success text-white" to="/ProductDetails">
                      <FavoriteBorderIcon />
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="btn btn-success text-white mt-2"
                      to="/ProductDetails"
                    >
                      <VisibilityIcon />
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="btn btn-success text-white mt-2"
                      to="/ProductDetails"
                    >
                      <AddShoppingCartIcon />
                    </NavLink>
                  </li>
                </ul>
              </div>
            </div>
            <div className="card-body">
              <NavLink to="/ProductDetails" className="h3 text-decoration-none">
                Oupidatat non
              </NavLink>
              <ul className="w-100 list-unstyled d-flex justify-content-between mb-0">
                <li>M/L/X/XL</li>
                <li className="pt-2">
                  <span className="product-color-dot color-dot-red float-left rounded-circle ml-1"></span>
                  <span className="product-color-dot color-dot-blue float-left rounded-circle ml-1"></span>
                  <span className="product-color-dot color-dot-black float-left rounded-circle ml-1"></span>
                  <span className="product-color-dot color-dot-light float-left rounded-circle ml-1"></span>
                  <span className="product-color-dot color-dot-green float-left rounded-circle ml-1"></span>
                </li>
              </ul>
              <ul className="list-unstyled d-flex justify-content-center mb-1">
                <li>
                  <StarIcon className="text-warning" />
                  <StarIcon className="text-warning" />
                  <StarIcon className="text-warning" />
                  <StarIcon className="text-muted" />
                  <StarIcon className="text-muted" />
                </li>
              </ul>
              <p className="text-center mb-0">$250.00</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Poducts;
